var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticStyle:{"margin-top":"3rem","margin-bottom":"1:rem"},attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"11"}},[_c('h2',{staticStyle:{"margin-bottom":"2rem"}},[_vm._v("About")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$store.state.globalTheme.ABOUT)}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bc2d766","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = null
// module chunks = 